// extracted by mini-css-extract-plugin
export default {"root":"mobile-preview-shell_root__R-1AP","host":"mobile-preview-shell_host__MSf7J","stage":"mobile-preview-shell_stage__ds-W9","viewport":"mobile-preview-shell_viewport__x0Mdi"};